import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './views/HomePage';
import StatsView from './views/StatsView';
import './App.css';

function App() {
  return (
    <Router basename="/defensenuggets">
      <div className="app">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/stats" element={<StatsView />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
